import * as React from "react";
import { ThemeProvider } from "@vebox/etui-system";
import { veboxDefaultTheme } from "../../../index";
import { ErrorBoundary } from "../../../ErrorBoundary/ErrorBoundary";
import { DefaultErrorBoundaryFallback } from "../../../ErrorBoundary/DefaultErrorBoundaryFallback";
import { SWRConfig, SWRConfiguration } from "swr";
import "./styles.scss";
import { MainPage } from "./pages/MainPage";
import { CensusCoolerProvider } from "./providers/CensusCollerProvider";
import { DataResponse } from "./data/models/RestApi";
import { JSONCensusAvailabilityCheckResult } from "./data/models/JSONCensusAvailabilityCheckResult";

type CensusCoolerProps = {
	fromCensusHistory?: boolean;
	isCensusFeatureAvailable: DataResponse<JSONCensusAvailabilityCheckResult>;
};

const options: SWRConfiguration = {
	revalidateOnFocus: false,
	revalidateOnReconnect: false,
	revalidateIfStale: false,
	revalidateOnMount: true,
	errorRetryInterval: 2000,
	errorRetryCount: 3,
	onError: (error, key) => {
		console.error("SWR error", error, key);
		return error;
	},
};

export const CensusCooler: React.FC<CensusCoolerProps> = ({
	fromCensusHistory,
	isCensusFeatureAvailable,
}) => {
	return (
		<ThemeProvider theme={veboxDefaultTheme}>
			<ErrorBoundary fallback={<DefaultErrorBoundaryFallback />}>
				<SWRConfig value={options}>
					<CensusCoolerProvider
						fromCensusHistory={fromCensusHistory}
						isCensusFeatureAvailable={isCensusFeatureAvailable}
					>
						<MainPage />
					</CensusCoolerProvider>
				</SWRConfig>
			</ErrorBoundary>
		</ThemeProvider>
	);
};
